import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import ChessBoard from "../components/chinese-chess/js/ChessBoard";
import ChessMen from "../components/chinese-chess/js/ChessMen";
import "./game-chinese-chess.css";

const GameChineseChessSection = () => {
  return (
    <Box sx={{ mt: -8 }}>
      {/* <Typography
        variant="h3"
        sx={{ position: "fixed", textAlign: "center", m: 4 }}
      >
        中國象棋
      </Typography> */}
      <div className="chinese-chess">
        <ChessBoard />
        <ChessMen />
      </div>
    </Box>
  );
};

export { GameChineseChessSection };
